import { Mesh } from "three";
export class ButtonMesh extends Mesh {
    set refButton(ref) {
        this._refButton = ref;
    }
    get refButton() {
        return this._refButton;
    }
}
